// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1YXXV","header":"ReportDetails_header__2mNIg","title":"ReportDetails_title__NNOn5","left":"ReportDetails_left__3PoUs"};